import { compose } from 'redux';
import { curry, isEmpty } from 'lodash-es';
import { ITEM_KINDS } from '../../constants';
import { not, filter, find, map, pick } from '../utils';
import { jsonApi } from '../http-request';

import { selectors as itemSelectors } from '../item';
import { selectors as moveSelectors } from '../move';
import { selectors as nameSelectors } from '../name';
import { selectors as sessionSelectors } from '../session';
import { selectors as siteConfigSelectors } from '../site-config';
import { selectors as userSelectors } from '../user';

const hasItemsInList = curry((list, state) =>
  compose(
    not,
    isEmpty,
    list
  )(state)
);

const exists = curry((item, state) =>
  compose(
    Boolean,
    item
  )(state)
);

const filterItemsByKind = curry((kind, state) =>
  compose(
    filter(item => item.kind(state) === kind),
    items
  )(state)
);

export const findItemByKind = curry((kind, state) =>
  compose(
    find(item => item.kind(state) === kind),
    items
  )(state)
);

export const move = state => moveSelectors.byId(user(state).moveId(state));

export const siteConfig = siteConfigSelectors.first;

export const user = state => userSelectors.byId(sessionSelectors.userId(state));

export const names = state =>
  nameSelectors.allByUserId(sessionSelectors.userId(state), state);

export const items = state =>
  itemSelectors.allByMoveId(move(state).id(state), state);

export const sessionHeader = state =>
  sessionSelectors.isSignedIn(state) ? sessionSelectors.headers(state) : {};

export const hasItems = hasItemsInList(items);
export const hasItemByKind = curry((kind, state) =>
  compose(
    Boolean,
    findItemByKind(kind)
  )(state)
);

export const forwardMailItems = filterItemsByKind(ITEM_KINDS.FORWARD_MAIL);
export const updateAccountItems = filterItemsByKind(ITEM_KINDS.UPDATE_ACCOUNT);
export const shareMoveItem = findItemByKind(ITEM_KINDS.SHARE);
export const hudsonInsuranceMoveItem = findItemByKind(
  ITEM_KINDS.HUDSON_INSURANCE
);

export const tvInternetItems = filterItemsByKind(ITEM_KINDS.HOME_SERVICES_APP);

export const hasForwardMailItems = hasItemsInList(forwardMailItems);
export const hasUpdateAccountItems = hasItemsInList(updateAccountItems);
export const hasShareMoveItem = exists(shareMoveItem);
export const hasHudsonInsuranceMoveItem = exists(hudsonInsuranceMoveItem);

// Returns the full entity objects which have slightly different fields than the
// entity objects in the site config.
// TODO: Create entity selectors?
export const entities = state =>
  compose(
    map(({ id, type }) =>
      jsonApi.selectors.resourceAttributesFromTypeAndId(type, id, state)
    ),
    map(pick(['id', 'type'])),
    siteConfig().entities
  )(state);
